import script from "./ServerEnrolmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServerEnrolmentModal.vue?vue&type=script&setup=true&lang=js"

import "./ServerEnrolmentModal.vue?vue&type=style&index=0&id=20267828&lang=scss"

const __exports__ = script;

export default __exports__